import { Loader2 } from "lucide-react";
import { CustomStatusView } from "@/types/chat";

interface StatusPillProps {
  status: CustomStatusView;
}

const LABELS: Record<string, string> = {
  compaction_start: 'Compacting context…',
};

export const StatusPill = ({ status }: StatusPillProps) => {
  const label = LABELS[status.name] || status.name.replace(/_/g, ' ');
  return (
    <div className="mb-2 inline-flex items-center gap-1.5 rounded-full border border-border/40 bg-muted/20 px-2.5 py-1 text-[11px] text-muted-foreground">
      <Loader2 className="h-3 w-3 animate-spin" />
      <span>{label}</span>
    </div>
  );
};
